export default __webpack_public_path__ + "static/insightPodcast-75a6c957ceb73f137de92c628db476b4.svg";